import { gql } from 'urql';

export const mutationDeleteEntity = gql`
  mutation DeleteEntity($entityCode: String!) {
    _removeEntity(entityCode: $entityCode)
  }
`;
